// extracted by mini-css-extract-plugin
export default {"image":"ImageNode_image__RoOv6","video":"ImageNode_video__-b2oo","document":"ImageNode_document__bfv2A","text":"ImageNode_text__3PipB"};